import $http from '../connectionProxy'

const FILE_UPLOAD_RESQUEST_TIMEOUT = 60000

export const get = (studentId) => {
  return $http.get(`/responsibles_area/students/${studentId}/show_documents`)
}

export const update = (studentId, documents) => {
  const formData = new FormData()

  Object.entries(documents).forEach(([ key, value ]) => {
    if (value) {
      formData.append(`student[${key}]`, value)
    }
  })

  return $http.put(`/responsibles_area/students/${studentId}/update_documents`, formData,
    { timeout: FILE_UPLOAD_RESQUEST_TIMEOUT, headers: { 'content-type': 'multipart/form-data' } })
}
